/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function RecycledPolyesterModel(props) {
	const { nodes, materials } = useGLTF("models/recycledPolyster.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube020.geometry}
				material={materials["recycle.001"]}
				position={[-0.01, 0.363, 0.013]}
				scale={[1.106, 0.411, 1.106]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube018.geometry}
				material={materials["Plain Brown Texture.001"]}
				position={[0.276, 0.037, 0.494]}
				rotation={[0, 1.38, 0.347]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube017.geometry}
				material={materials["Plain Black Texture.001"]}
				position={[0.141, 0.154, 0.615]}
				rotation={[0, 1.15, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube016.geometry}
				material={materials["Plain Blue Texture.001"]}
				position={[-0.149, 0.141, 0.615]}
				rotation={[0, 0.824, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube015.geometry}
				material={materials["Stripe Green Dimout.001"]}
				position={[-0.444, 0.124, 0.615]}
				rotation={[0, 0.529, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube014.geometry}
				material={materials["Stripe Blue Dimout.001"]}
				position={[-0.715, 0.114, 0.615]}
				rotation={[0, 0.263, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube013.geometry}
				material={materials["Plain Green Texture.001"]}
				position={[-1.031, 0.094, 0.615]}
				rotation={[0, 0, 0.307]}
				scale={[1.44, 1.44, 0.199]}
			/>
		</group>
	);
}

useGLTF.preload("models/recycledPolyster.glb");
